var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('b-navbar',{attrs:{"type":"dark","variant":"dark"}},[_c('b-container',[_c('b-row',[_c('b-col',{attrs:{"cols":"1"}},[_c('b-navbar-brand',{staticClass:"mx-auto"},[_vm._v(" Nous contacter")])],1)],1)],1),_c('th')],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }